import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NewsletterService } from '../../../services/newsletter.service';

@Component({
  selector: 'app-newsletter-list',
  templateUrl: './newsletter-list.component.html',
  styleUrls: ['./newsletter-list.component.scss']
})
export class NewsletterListComponent implements OnInit {

  campaigns: any[] = [];
  loading: boolean = false;
  errorMessage: string = '';

  constructor(
    private newsletterService: NewsletterService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadCampaigns();
  }

  loadCampaigns(): void {
    this.loading = true;
    this.errorMessage = '';

    this.newsletterService.getCampaigns().subscribe({
      next: (data) => {
        this.campaigns = data || [];
        this.loading = false;
      },
      error: (err) => {
        this.errorMessage = 'No se pudieron cargar las campañas.';
        this.loading = false;
        console.error(err);
      }
    });
  }

  goToNew(): void {
    this.router.navigate(['/newsletter/new']);
  }

  goToTemplates(): void {
    this.router.navigate(['/newsletter/templates']);
  }

  goToDetail(id: number): void {
    this.router.navigate(['/newsletter', id]);
  }

  goToEdit(event: Event, id: number): void {
    event.stopPropagation();
    this.router.navigate(['/newsletter', id, 'edit']);
  }

  deleteCampaign(event: Event, id: number): void {
    event.stopPropagation();
    if (!confirm('¿Seguro que quieres eliminar esta campaña?')) return;

    this.newsletterService.deleteCampaign(id).subscribe({
      next: () => this.loadCampaigns(),
      error: (err) => {
        alert('No se pudo eliminar: ' + (err.error || 'Error desconocido'));
      }
    });
  }

  cancelCampaign(event: Event, id: number): void {
    event.stopPropagation();
    if (!confirm('¿Cancelar esta campaña programada?')) return;

    this.newsletterService.cancelCampaign(id).subscribe({
      next: () => this.loadCampaigns(),
      error: (err) => {
        alert('No se pudo cancelar: ' + (err.error || 'Error desconocido'));
      }
    });
  }

  statusLabel(status: string): string {
    const labels: any = {
      'DRAFT': 'Borrador',
      'SCHEDULED': 'Programada',
      'SENDING': 'Enviando',
      'SENT': 'Enviada',
      'FAILED': 'Fallida',
      'CANCELLED': 'Cancelada'
    };
    return labels[status] || status;
  }

  statusClass(status: string): string {
    const classes: any = {
      'DRAFT': 'badge-draft',
      'SCHEDULED': 'badge-scheduled',
      'SENDING': 'badge-sending',
      'SENT': 'badge-sent',
      'FAILED': 'badge-failed',
      'CANCELLED': 'badge-cancelled'
    };
    return classes[status] || '';
  }
}


